export enum GlobalProductBarcodeScannerRoutes {
  BASE = 'scan-code',
  SCANNER = 'scanner',
  RESULT = 'result',
  NO_RESULT = 'no-result'
}
